import { render, staticRenderFns } from "./dokumentasi.vue?vue&type=template&id=1c993438"
import script from "./dokumentasi.vue?vue&type=script&lang=js"
export * from "./dokumentasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports